import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";

import { ActivatedRoute, Router } from "@angular/router";
import { SasagreementComponent } from "../sasagreement/sasagreement.component";

@Component({
  selector: "app-healthsyshome",
  templateUrl: "./healthsyshome.component.html",
  styleUrls: ["./healthsyshome.component.scss"],
})
export class HealthsyshomeComponent implements OnInit {
  constructor(private router: Router, public dialog: MatDialog) {}

  ngOnInit() {}

  contact() {
    this.router.navigate(["/appypartnercontactinfo"]);
  }

  Signup() {
    this.router.navigate(["/signup"]);
    // this.openDialog();
    // const redirectUrl = '/app/physician/profile/setupOrganization';
    // window.location.href = `/Session/SignUp?redirectUrl=${redirectUrl}`;
  }
  openDialog() {
    const dialogRef = this.dialog.open(SasagreementComponent, {
      data: {
        orgData: "panda",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }
}
